import { render, staticRenderFns } from "./PlatformGuide_list.vue?vue&type=template&id=3d24e366&scoped=true"
import script from "./PlatformGuide_list.vue?vue&type=script&lang=js"
export * from "./PlatformGuide_list.vue?vue&type=script&lang=js"
import style0 from "./PlatformGuide_list.vue?vue&type=style&index=0&id=3d24e366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24e366",
  null
  
)

export default component.exports